/**
 * Hardware Buildup
 * Hardware Buildup
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 1 = Button, 2 = Relay, 3 = MonoLight, 4 = Temperature, 5 = Humidity, 6 = Pir, 7 = Lux, 11 = Rgb, 12 = TunableWhite, 15 = AnalogSensorModel, 16 = CbShutter, 18 = Heater, 19 = PbShutter, 20 = Scheduler, 21 = Timer, 22 = Gateway, 23 = Threshold, 24 = LinkTranslator, 25 = Rain, 26 = PergolaProtection, 27 = Louvres, 28 = Repeater, 31 = Wind, 32 = Counter, 33 = AccessCode, 34 = Garage, 37 = Beam, -1 = Unknown
 */
export enum ModelTypeIds {
    Button = 1,
    Relay = 2,
    MonoLight = 3,
    Temperature = 4,
    Humidity = 5,
    Pir = 6,
    Lux = 7,
    Rgb = 11,
    TunableWhite = 12,
    AnalogSensorModel = 15,
    CbShutter = 16,
    Heater = 18,
    PbShutter = 19,
    Scheduler = 20,
    Timer = 21,
    Gateway = 22,
    Threshold = 23,
    LinkTranslator = 24,
    Rain = 25,
    PergolaProtection = 26,
    Louvres = 27,
    Repeater = 28,
    Wind = 31,
    Counter = 32,
    AccessCode = 33,
    Garage = 34,
    Beam = 37,
    Unknown = -1
}

